import remove from 'lodash/remove'

export default {
  setUserGroups: (state, userGroups) => {
    remove(userGroups, { recordInactiveFlag: 'I' })
    state.userGroups = userGroups
  },
  setUsersForUserGroup: (state, usersForUserGroup) => {
    state.usersForUserGroup = usersForUserGroup
  },
  setShowUserGroupModal: (state, showUserGroupModal) => {
    state.showUserGroupModal = showUserGroupModal
  },
  setSelectedUserGroupInformation: (state, selectedUserGroupInfo) => {
    state.selectedUserGroupInfo = selectedUserGroupInfo
  },
  setShowRemoveUserModal: (state, showRemoveUserModal) => {
    state.showRemoveUserModal = showRemoveUserModal
  },
  setUserList: (state, userList) => {
    state.userList = userList
  },
  setShowUsersModal: (state, showUsersModal) => {
    state.showUsersModal = showUsersModal
  },
  setUserGroupsForUser: (state, userGroupsForUser) => {
    state.userGroupsForUser = userGroupsForUser
  },
  setSelectedUser: (state, selectedUser) => {
    state.selectedUser = selectedUser
  },
  setUserHistory: (state, userHistory) => {
    state.userHistory = userHistory
  },
  setUserGroupHistory: (state, userGroupHistory) => {
    state.userGroupHistory = userGroupHistory
  }
}
